<!-- Same drawer as Bills to Pay's filter panel (shared styles/_filter-panel.scss). -->
<div class="groups-panel" *ngIf="isOpen">
  <header class="groups-panel__header">
    <h2>{{ panelTitle }}</h2>
    <span class="groups-panel__close" title="Close" (click)="close()">
      <img src="../../../../assets/img/close-icon.svg" alt="Close" />
    </span>
  </header>

  <div class="groups-panel__body">

    <!-- Only while the filter is being saved. Applying it once needs no name. -->
    <div class="filter-name" *ngIf="isNaming">
      <i class="fa fa-bookmark-o filter-name__icon" aria-hidden="true"></i>
      <input #nameInput class="filter-name__input" type="text" maxlength="60" aria-label="Filter name"
             placeholder="Name this filter" [(ngModel)]="draftName" />
      <button type="button" class="filter-name__cancel" *ngIf="!isEditingSaved"
              title="Apply it without saving" (click)="cancelNaming()">
        Don't save
      </button>
      <button type="button" class="filter-name__delete" *ngIf="isEditingSaved"
              title="Delete this filter" (click)="deleteFilter()">
        <i class="fa fa-trash-o"></i>
      </button>
    </div>

    <div class="filter-desc" *ngIf="isNaming">
      <textarea class="filter-desc__input" rows="2" maxlength="200" aria-label="Filter description"
                placeholder="What is this filter for?" [(ngModel)]="draftDesc"></textarea>
    </div>

    <div class="conditions__head">
      <span class="conditions__title">Documents that match</span>
      <span class="conditions__add"
            [class.conditions__add--disabled]="hasOpenCondition"
            [title]="addConditionTitle"
            (click)="addCondition()">
        <i class="fa fa-plus"></i> Add condition
      </span>
    </div>

    <div class="conditions">
      <div class="condition"
           *ngFor="let condition of draft; let i = index; trackBy: trackByIndex"
           [class.condition--open]="!condition?.confirmed">

        <!-- Confirmed: one line -->
        <div class="condition__done" *ngIf="condition?.confirmed">
          <i class="fa fa-check-circle condition__check"></i>
          <div class="condition__text">
            <div class="condition__step">{{ stepLabel(i) }}</div>
            <div class="condition__summary">{{ summaryOf(condition) }}</div>
          </div>
          <i class="fa fa-pencil condition__icon-btn" title="Edit" (click)="editCondition(i)"></i>
          <i class="fa fa-times condition__icon-btn condition__icon-btn--danger" title="Remove"
             (click)="removeCondition(i)"></i>
        </div>

        <!-- Open for editing -->
        <div class="condition__editor" *ngIf="condition && !condition.confirmed">
          <div class="condition__editor-head">
            <span class="condition__step condition__step--active">{{ stepLabel(i) }}</span>
            <i class="fa fa-times condition__icon-btn condition__icon-btn--danger" title="Remove"
               (click)="removeCondition(i)"></i>
          </div>

          <div class="condition__fields">
            <app-filter-value-select label="Field to filter on" [options]="availableFields"
                                     [value]="condition.field" (valueChange)="onFieldChange(i, $event)">
            </app-filter-value-select>

            <app-filter-value-select label="Comparison" [options]="opsFor(condition)"
                                     [value]="condition.op" (valueChange)="onOpChange(i, $event)">
            </app-filter-value-select>

            <!-- Several values at once: the search matches any of them. -->
            <app-filter-value-select *ngIf="showSelectValue(condition)" label="Values" [multiple]="true"
                                     placeholder="Select one or more"
                                     [options]="valueOptionsFor(condition)" [values]="valuesOf(condition)"
                                     (valuesChange)="onValuesChange(i, $event)">
            </app-filter-value-select>

            <ng-container *ngIf="showDateValue(condition)">
              <div class="condition__range" *ngIf="isRangeOp(condition); else singleDate">
                <input class="condition__control" type="date" title="From date" [ngModel]="condition.value"
                       (ngModelChange)="onValueChange(i, $event)" />
                <span class="condition__range-sep">and</span>
                <input class="condition__control" type="date" title="To date" [ngModel]="condition.valueTo"
                       (ngModelChange)="onValueToChange(i, $event)" />
              </div>
              <ng-template #singleDate>
                <input class="condition__control" type="date" title="Date" [ngModel]="condition.value"
                       (ngModelChange)="onValueChange(i, $event)" />
              </ng-template>
            </ng-container>

            <ng-container *ngIf="showNumberValue(condition)">
              <div class="condition__range" *ngIf="isRangeOp(condition); else singleNumber">
                <input class="condition__control" type="number" step="0.01" title="From amount" placeholder="0.00"
                       [ngModel]="condition.value" (ngModelChange)="onValueChange(i, $event)" />
                <span class="condition__range-sep">and</span>
                <input class="condition__control" type="number" step="0.01" title="To amount" placeholder="0.00"
                       [ngModel]="condition.valueTo" (ngModelChange)="onValueToChange(i, $event)" />
              </div>
              <ng-template #singleNumber>
                <input class="condition__control" type="number" step="0.01" title="Amount" placeholder="0.00"
                       [ngModel]="condition.value" (ngModelChange)="onValueChange(i, $event)" />
              </ng-template>
            </ng-container>
          </div>

          <div class="condition__editor-foot">
            <span class="condition__preview"></span>
            <button type="button" class="condition__done-btn" [disabled]="!isComplete(condition)"
                    (click)="confirmCondition(i)">Done</button>
          </div>
        </div>
      </div>
    </div>

    <div class="match-summary" *ngIf="canApply">
      <i class="fa fa-check-circle"></i>
      <span>Shows documents where {{ ruleText }}</span>
    </div>

  </div>

  <footer class="groups-panel__footer">
    <ng-container *ngIf="isNaming">
      <button type="button" class="btn-secondary" [disabled]="!canApply" (click)="applyFilter()"
              title="Apply these conditions without saving them">Apply once</button>
      <button type="button" class="btn-primary" [disabled]="!canApply" (click)="saveFilter()">{{ saveLabel }}</button>
    </ng-container>

    <ng-container *ngIf="!isNaming">
      <button type="button" class="btn-secondary" [disabled]="!canApply" (click)="startNaming()">Save filter</button>
      <button type="button" class="btn-primary" [disabled]="!canApply" (click)="applyFilter()">Apply filters</button>
    </ng-container>
  </footer>
</div>
